<template>

    <toast position="bottom-right" />

    <div :class="containerClass" @click="onWrapperClick">
        <AppTopBar />

        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>

        <div class="layout-main-container">

            <div class="layout-main" style="position:relative">
                <!-- <breadcrumb :home="breadcrumb.menu.home" :model="breadcrumb.menu.items" />  -->

                <router-view /> <!-- router-view -->
            </div>
            <AppFooter />
        </div>

        <AppConfig :layoutMode="layoutMode" :layoutColorMode="layoutColorMode" @layout-change="onLayoutChange"
            @layout-color-change="onLayoutColorChange" />
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
    </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';
import roles from '@/config/roles'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import store from "./store/index";

const MENU_BADGES_INTERVAL_MS = 10 * 60 * 1000

export default {
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        'AppFooter': AppFooter,
    },
    data() {
        return {
            loading: false,
            pageName: '',
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            nb: 0,
            modificheCountRequestId: 0,
            modificheCountHandler: null,
            menuBadgesInterval: null,
            service: new Service(this.$eventBus),
            menu: [
                {
                    items: [
                        // {label: 'Home', icon: 'pi pi-fw pi-home', to: '/', visibility:[ roles.admin.role, roles.agent.role]},
                        // {label: "Nuovo Cliente", icon:'pi pi-user', to: '/clienti', visibility:[roles.admin.role]},
                        // {label: 'Nuovo Rappresentante', icon: 'pi pi-user-plus', to: '/rappresentanti', visibility:[roles.admin.role]},
                        // {label: 'Nuovo Contratto', icon: 'pi pi-file-excel', to: '/contratti', visibility:[roles.admin.role]},  
                        // {label: 'Nuova Offerta', icon: 'pi pi-file-o', to: '/offerte', visibility:[roles.admin.role]},  
                        // {label: 'Nuovo Fornitore', icon: 'pi pi-sitemap', to: '/fornitori', visibility:[roles.admin.role]},
                        // {label: 'Nuovo Agente', icon: 'pi pi-eye', to: '/agenti', visibility:[roles.admin.role]},
                        // {label: 'Nuova Fornitura Energia', icon: 'pi pi-power-off', to: '/forniture-ee', visibility:[roles.admin.role]},
                        // {label: 'Nuova Fornitura Gas', icon: 'pi pi-cloud-upload', to: '/forniture-gas', visibility:[roles.admin.role]}, 
                        // {label: 'Nuovo Inserimento', icon: 'pi pi-id-card', to: '/agenti/inserimento', visibility:[roles.admin.role]}, 
                        { label: 'Nuovo Contratto', icon: 'pi pi-file', to: '/multisito', visibility: [roles.admin.role, roles.agent.role], profiles: ['all', 'backoffice', 'assistenza_clienti'] },
                        { label: 'Storico Caricamenti', icon: 'pi pi-clock', to: '/caricamenti-multisito', visibility: [roles.admin.role, roles.agent.role], profiles: ['all', 'backoffice', 'assistenza_clienti'] },
                        { label: 'Statistiche Caricamenti', icon: 'pi pi-clock', to: '/statistiche-caricamenti', visibility: [roles.admin.role], profiles: ['all','pratiche'] },
                        { label: 'Recupero usciti', icon: 'pi pi-clock', to: '/recupero-usciti', visibility: [roles.admin.role, roles.agent.role], profiles: ['all', 'backoffice'], need_authorization_swo_recovery: 1 },

                        { label: 'Riepilogo validazioni', icon: 'pi pi-list', to: '/validazione-caricamenti', visibility: [roles.admin.role], profiles: ['all', 'backoffice', 'assistenza_clienti'] },

                        { label: 'Valida Contratti', icon: 'pi pi-check', to: '/validazione-caricamenti-validatori', visibility: [roles.admin.role], profiles: ['all', 'backoffice', 'validazione'] },
                        { label: 'Statistiche Validatori', icon: 'pi pi-check', to: '/statistiche-validatori', visibility: [roles.admin.role], profiles: ['all'] },

                        { label: 'Convalida Modifiche', icon: 'pi pi-pencil', to: '/convalida-modifiche', visibility: [roles.admin.role], profiles: ['all', 'backoffice', 'assistenza_clienti'] },

                        { label: 'Gestione Pratiche', icon: 'pi pi-folder', to: '/precheck-iv', visibility: [roles.admin.role], profiles: ['all', 'pratiche'] },
                        { label: 'Scarico mensile AGF', icon: 'pi pi-download', to: '/scarico-agf', visibility: [roles.admin.role], profiles: ['all', 'backoffice'] },
                        { label: 'Report mensili', icon: 'pi pi-chart-line', to: '/report-caricamenti-agente', visibility: [roles.admin.role, roles.agent.role], profiles: ['all', 'backoffice'] },
                        { label: 'Stato fornitura', icon: 'pi pi-info-circle', to: '/stato-fornitura', visibility: [roles.admin.role], profiles: ['all'] },
                        { label: 'Forniture contrattualizzate', icon: 'pi pi-check-circle', to: '/forniture-in-wizard', visibility: [roles.admin.role], profiles: ['all', 'backoffice', 'assistenza_clienti'] },
                        { label: 'Nuove posa contatore', icon: 'pi pi-search', to: '/forniture-non-trovate-rcu', visibility: [roles.admin.role], profiles: ['all','backoffice'] },
                        { label: 'Convenzioni', icon: 'pi pi-tag', to: '/convenzioni-agf', visibility: [roles.admin.role], profiles: ['all', 'backoffice'] },
                        {
                            label: 'Allerta Caricamenti',
                            icon: 'pi pi-list',
                            to: '/allerta-caricamenti',
                            visibility: [roles.admin.role],
                            profiles: ['all',"pratiche"]
                        },
                        // { label: 'Contratti', icon: 'pi pi-file-pdf', to: '/accettazione-contratti-agf', visibility: [roles.admin.role], profiles: ['all', 'backoffice'] },
                        // { label: 'Credito Fattura', icon: 'pi pi-wallet', to: '/credito-fattura', visibility: [roles.admin.role], profiles: ['all', 'backoffice'] },
                        // { label: 'Recupero Credito', icon: 'pi pi-refresh', to: '/recupero-credito', visibility: [roles.admin.role], profiles: ['all', 'backoffice'] },
                        // Menu Dashboard:
                        {
                            label: 'Gestione Reclami',
                            icon: 'pi pi-exclamation-circle',
                            visibility: [roles.admin.role],
                            profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo'],
                            items: [
                                {
                                    label: 'Inserimento Reclami',
                                    icon: 'pi pi-plus',
                                    to: '/gestione-reclami',
                                    visibility: [roles.admin.role],
                                    profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
                                },
                                {
                                    label: 'Storico Reclami',
                                    icon: 'pi pi-list',
                                    to: '/gestione-reclami/storico',
                                    visibility: [roles.admin.role],
                                    profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
                                },

                            ]
                        },
                        { 
                            label: 'Accedi ad Ask Technology', 
                            icon: 'pi pi-clock', 
                            external_url: `${process.env.VUE_APP_ASK_TECHNOLOGY}/dashboard`, 
                            visibility: [roles.admin.role, roles.agent.role], 
                            profiles: ['all'], 
                            need_authorization_access_ask_technology: 1 
                        },
                    ]

                },
            ],
            breadcrumb: {
                menu: {
                    home: { icon: 'pi pi-fw pi-home', to: '/' },
                    items: [
                        { label: 'Dashboard' },
                    ]
                }
            },
            can_recovery_swo: false,
            can_access_ask_technology: false,
            user: null
        }
    },

    created() {
        this.can_recovery_swo = store.state.auth.user.swo_recovery
        this.can_access_ask_technology = store.state.auth.user.can_access_ask_technology
        this.user = store.state.auth.user

        this.getNbModifiche()
        this.updatePpsNotFoundRcuBadge()
        this.menuBadgesInterval = window.setInterval(() => {
            this.getNbModifiche()
            this.updatePpsNotFoundRcuBadge()
        }, MENU_BADGES_INTERVAL_MS)

        this.$eventBus.on('page-change', (evt) => {
            this.breadcrumb.menu.items = [{ label: evt.currentRoute.name }]
        })
        this.modificheCountHandler = () => this.getNbModifiche()
        this.$eventBus.on('modifiche-count-changed', this.modificheCountHandler)
        this.$eventBus.on('data-loading', () => {
            // this.loading = true
        })
        this.$eventBus.on('data-loaded', () => {
            // this.loading = false
        })
        this.$eventBus.on('data-load-success', (evt) => {
            this.$toast.add({
                severity: 'success',
                summary: 'Successo',
                detail: `${evt.message}`,
                life: 4000
            })
            //   this.loading = false
        })
        this.$eventBus.on('data-load-error', (evt) => {
            this.$toast.add({
                severity: 'warn',
                summary: 'Error Message',
                detail: `message: ${evt.message} url: ${evt.url}`,
                life: 4000
            })
            //   this.loading = false
        })
        this.$eventBus.on('menu-toggle', (event) => {
            this.menuClick = true;
            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        })
        setTimeout(() => {
            this.openWrapper()
        }, 2000)
    },

    /////// BEGIN THEME
    watch: {
        $route(route) {
            this.menuActive = false;
            this.$toast.removeAllGroups();
            if (route.path === '/convalida-modifiche') {
                this.getNbModifiche()
            }
        },
    },
    methods: {
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },

        onSidebarClick() {
            this.menuClick = true;
        },

        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        openWrapper() {
            let element = document.querySelector("[href='#']")
            if (element) {
                element.click()
            }
        },
        async getNbModifiche() {
            const requestId = ++this.modificheCountRequestId
            await this.service.getNbModifiche()
                .then((res) => {
                    if (requestId !== this.modificheCountRequestId) return
                    if (Array.isArray(res.items) || !Number.isFinite(Number(res.items))) return
                    this.nb = res.items
                    this.setMenuItemBadge('Convalida Modifiche', this.nb)
                })
        },
        findMenuItemByLabel(items, label) {
            for (const item of items || []) {
                if (item.label === label) return item

                const child = this.findMenuItemByLabel(item.items, label)
                if (child) return child
            }

            return null
        },
        setMenuItemBadge(label, value) {
            const item = this.findMenuItemByLabel(this.menu, label)
            if (!item) return

            const count = Number(value) || 0
            item.badge = count > 0 ? count : null
        },
        async updatePpsNotFoundRcuBadge() {
            const res = await this.service.getPpsNotFoundRcuAssociableCount()
            this.setMenuItemBadge('Nuove posa contatore', res.items?.count)
        },
        onLayoutChange(layoutMode) {
            this.layoutMode = layoutMode;
        },

        onLayoutColorChange(layoutColorMode) {
            this.layoutColorMode = layoutColorMode;
        },

        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },

        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },

        isDesktop() {
            return window.innerWidth >= 992;
        },

        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false,
                'layout-theme-light': this.$appState.theme.startsWith('saga'),
            }];
        },
        logo() {
            return (this.layoutColorMode === 'dark') ? "images/logo-white.svg" : "images/logo.svg";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    beforeUnmount() {
        if (this.modificheCountHandler) {
            this.$eventBus.off('modifiche-count-changed', this.modificheCountHandler)
            this.modificheCountHandler = null
        }
        if (this.menuBadgesInterval) {
            window.clearInterval(this.menuBadgesInterval)
            this.menuBadgesInterval = null
        }
    },
}
</script>

<style lang="scss">
// @import './App.scss';
.p-breadcrumb {
    margin-bottom: 20px;
}
</style>
